import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { accountCreationSchema, type AccountCreationFormValues } from './AccountCreationForm.schema';

export interface UseAccountCreationFormOptions {
    initialFirstName: string;
    initialLastName: string;
    initialCompanyName: string;
}

export function useAccountCreationForm({
    initialFirstName,
    initialLastName,
    initialCompanyName,
}: UseAccountCreationFormOptions) {
    return useForm<AccountCreationFormValues>({
        mode: 'onSubmit',
        defaultValues: {
            firstName: initialFirstName,
            lastName: initialLastName,
            companyName: initialCompanyName,
        },
        resolver: zodResolver(accountCreationSchema),
    });
}
